import { createRoot } from "react-dom/client";
import { App } from "./App";
import { reportError } from "./ui/report";

// Surface uncaught FE errors to the backend log — they otherwise only exist in
// the user's browser (the gap behind the unseen iPhone upload failure).
window.addEventListener("error", (e) => reportError("window.error", e.error ?? e.message));
window.addEventListener("unhandledrejection", (e) => reportError("unhandledrejection", e.reason));

createRoot(document.getElementById("root")!).render(<App />);
